import React from "react";
import { Grid } from "@mui/material";

const ProgressBar: React.FC<{ percentComplete: string }> = ({ percentComplete }) => (
  <Grid size={{ xs: 12 }}>
    <div className="progress">
      <div className="progress-bar" style={{ width: percentComplete }} >
        <span className="sr-only">{percentComplete}</span>
      </div>
    </div>
  </Grid>
);

export default ProgressBar;
